const CkeditorCollectionInput = Backbone.View.extend({

    tagName: 'div',
    className: 'form-group ckeditor-collection-input',
    template: JST.ckeditorCollectionInputTpl,
    events: {
        'click .add-button': 'addItem',
        'click .delete-item': 'deleteItem'
    },
    initialize(opts) {
        var getEditIdInternal = this.getEditId
        this.$el.html('');

        this.collection.each(function (model, index) {
            model.set("id", getEditIdInternal(model, index));
        });
        _.extend(this, opts);
        this.listenTo(this.collection, 'remove', this.render);

        return this;
    },
    render() {
        const html = this.template({
            collection: this.collection,
            getEditId: this.getEditId,
            modelKey: this.modelKey
        });
        console.log('ckeditor collection', this.collection);
        this.$el.html(html);
        return this.el;
    },
    addCkeditor() {

        var getEditIdInternal = this.getEditId;
        this.collection.each(function (model, index) {
            model.set("id", getEditIdInternal(model, index));

            var ckEditorId = getEditIdInternal(model, index);
            CKEDITOR.replace(ckEditorId);
            //in case that ckeditor instance has data clear it
            CKEDITOR.instances[ckEditorId].setData('');
        });
    },
    fillInsights() {
        var getEditIdInternal = this.getEditId;
        var elements = this.$el;
        this.collection.each(function (model, index) {
            model.set("id", getEditIdInternal(model, index));
            CKEDITOR.instances[getEditIdInternal(model, index)].setData(model.get('Insight'));
            //elements.find("textarea[name='" + getEditIdInternal(model, index) + "']").val(model.get('Insight'));
        });
    },
    addItem(e) {
        e.preventDefault()
        e.stopPropagation();

        var model = {
            Insight: ""
        }
        this.collection.add(model);
        this.restartInsights();
    },
    deleteItem(e) {
        const id = $(e.target).parent().data('modelid');
        this.getCurrentEdits();
        this.removeCkEditorInstance(id);
        this.collection.remove(`${id}`);
        this.render();
        this.addCkeditor();
        this.fillInsights();
    },
    getValue() {
        this.getCurrentEdits();
        return this.collection.toJSON();
    },
    getEditId(model, index) {
        return `InsightId_${index}_${model.get('InsightId')}`;
    },
    getCurrentEdits() {
        var getEditIdInternal = this.getEditId;
        var elements = this.$el;
        this.collection.each(function (model, index) {
            var element = elements.find("textarea[name='" + getEditIdInternal(model, index) + "']");
            //if the instance and the element exist read data
            if (CKEDITOR.instances[getEditIdInternal(model, index)] && element && element.length > 0) {
                model.set('Insight', CKEDITOR.instances[getEditIdInternal(model, index)].getData());
            }
            model.set("id", getEditIdInternal(model, index));
        });
    },
    removeCkEditorInstance(instanceId) {
        if (CKEDITOR.instances.hasOwnProperty(instanceId)) {
            CKEDITOR.instances[instanceId].destroy(true);
        }

    },
    restartInsights() {
        this.getCurrentEdits();
        this.render();
        this.addCkeditor();
        this.fillInsights();
    }
});

export default CkeditorCollectionInput;
